export default {"src":"/_next/static/media/file-delete.b595b441.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};